import { render, staticRenderFns } from "./HotelFlightAppDesktop.vue?vue&type=template&id=9de2fb5a&scoped=true"
import script from "./HotelFlightAppDesktop.vue?vue&type=script&lang=js"
export * from "./HotelFlightAppDesktop.vue?vue&type=script&lang=js"
import style0 from "./HotelFlightAppDesktop.vue?vue&type=style&index=0&id=9de2fb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de2fb5a",
  null
  
)

export default component.exports